import {Button} from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import iconSize from 'Theme/Icon';

const RefreshButton = ({refresh, image}) => {
  return (
    <Button
      type="text"
      aria-label="Refresh list"
      onClick={refresh}
      style={{padding: 0, marginLeft: 8}}>
      <img src={image} style={iconSize} alt="Refresh list" />
    </Button>
  );
};

RefreshButton.propTypes = {
  refresh: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
};

export default RefreshButton;
